//@ts-nocheck
import React from 'react';
import styled from 'styled-components';

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 5px;
`;

const PageButton = styled.button`
  min-width: 35px;
  height: 35px;
  border: 1px solid #dee2e6;
  background: ${(props) => (props.active ? '#007bff' : 'white')};
  color: ${(props) => (props.active ? 'white' : '#007bff')};
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  &:hover {
    background: ${(props) =>
      props.disabled
        ? props.active
          ? '#007bff'
          : 'white'
        : props.active
        ? '#0056b3'
        : '#e9ecef'};
  }
`;

const PageInfo = styled.span`
  margin: 0 15px;
  color: #6c757d;
  font-size: 14px;
`;

const OrdersPagination = ({ pagination, onPageChange }) => {
  const { page, pages, total, limit } = pagination;

  const generatePaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(pages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    items.push(
      <PageButton
        key="prev"
        disabled={page === 1}
        onClick={() => page > 1 && onPageChange(page - 1)}
      >
        ‹
      </PageButton>,
    );

    // First page
    if (startPage > 1) {
      items.push(
        <PageButton key={1} onClick={() => onPageChange(1)}>
          1
        </PageButton>,
      );
      if (startPage > 2) {
        items.push(<span key="ellipsis1">...</span>);
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <PageButton
          key={i}
          active={i === page}
          onClick={() => onPageChange(i)}
        >
          {i}
        </PageButton>,
      );
    }

    // Last page
    if (endPage < pages) {
      if (endPage < pages - 1) {
        items.push(<span key="ellipsis2">...</span>);
      }
      items.push(
        <PageButton key={pages} onClick={() => onPageChange(pages)}>
          {pages}
        </PageButton>,
      );
    }

    // Next button
    items.push(
      <PageButton
        key="next"
        disabled={page === pages}
        onClick={() => page < pages && onPageChange(page + 1)}
      >
        ›
      </PageButton>,
    );

    return items;
  };

  if (pages <= 1) return null;

  return (
    <PaginationWrapper>
      {generatePaginationItems()}
      <PageInfo>
        Strona {page} z {pages} ({total} elementów)
      </PageInfo>
    </PaginationWrapper>
  );
};

export default OrdersPagination;
